import { Form, Row, Col, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { CloseOutlineIcon } from "@components/icons";
import { ITree } from "../../../../../interfaces";

export default function TreeNoSensor({ values, setFieldValue, childOption }) {
  const [inputFields, setInputFields] = useState([]);

  const { t } = useTranslation();

  useEffect(() => {
    const b = [];
    values?.trees?.map((a: ITree) => {
      b.push({
        id: a.id,
        name: a.name,
        represented_trees: a.represented_trees,
        installations: a.installations,
        has_active_sensors: a.has_active_sensors,
      });
    });
    setInputFields(b);
  }, []);

  useEffect(() => {
    setFieldValue("trees", inputFields);
  }, [inputFields]);

  const handleFormChange = (index: number, event) => {
    const data = [...inputFields];
    if (event.target && event.target.name === "id") {
      const selectedTreeId = event.target.value;
      // Find the selected tree from childOption to get the full tree data
      const selectedTree = childOption.find((tree: ITree) => tree.id == selectedTreeId);
      if (selectedTree) {
        data[index]["id"] = selectedTree.id;
        data[index]["name"] = selectedTree.name;
        // Preserve other properties if they exist
        if (!data[index]["represented_trees"]) {
          data[index]["represented_trees"] = [];
        }
        // Preserve both sensor data structures for compatibility
        if (selectedTree.installations !== undefined) {
          data[index]["installations"] = selectedTree.installations || [];
        }
        if (selectedTree.has_active_sensors !== undefined) {
          data[index]["has_active_sensors"] = selectedTree.has_active_sensors;
        }
      }
    } else {
      data[index]["represented_trees"] = event;
    }
    setInputFields(data);
  };

  const addFields = () => {
    const newfield = {};
    setInputFields([...inputFields, newfield]);
  };

  const handleRemove = (index: number) => {
    const filtered = inputFields.filter((a: ITree, i) => i !== index);
    setInputFields(filtered);
  };
  const childIds = childOption.map((tree: ITree) => {
    return +tree.id;
  });

  // Show only trees that do NOT have sensors
  const isTreeNoSensor = (tree: Partial<ITree>) => {
    if (!tree.id) return true; // Allow empty/new entries

    // Check for installations first (legacy), then fall back to has_active_sensor
    if (tree.installations !== undefined) {
      return !tree.installations || tree.installations.length === 0;
    }
    return tree.has_active_sensors !== true;
  };

  return (
    <div>
      <Row>
        <Col lg={5}>
          <h6>{t("tree_without_sensor")}</h6>
        </Col>
      </Row>
      {inputFields?.map((field: ITree, index) => {
        // Only render trees without sensors or empty entries
        if (!isTreeNoSensor(field)) return null;

        const selectedTree = childOption.find((tree: ITree) => tree.id == field.id);
        return (
          <Row className="g-1 mb-2" key={index}>
            <Col lg={5}>
              <div>
                <Form.Select
                  name="id"
                  style={{ height: "38px" }}
                  onChange={(event) => handleFormChange(index, event)}
                  value={field.id || ""}
                  defaultValue={"Choose Tree"}
                >
                  <option value="">Choose Tree</option>
                  {/* Show all possible child trees (trees without sensors) */}
                  {childOption?.map((tree: ITree) => (
                    <option value={tree.id} key={tree.id}>
                      {tree.name}
                    </option>
                  ))}

                  {/* Also include existing tree if it's not in childOption but is currently selected */}
                  {field.id && !childIds.includes(+field.id) && (
                    <option value={field.id} key={`existing-${field.id}`}>
                      {field.name}
                    </option>
                  )}
                </Form.Select>
              </div>
            </Col>
            <Col>
              <Button
                variant="outline-primary"
                className="border-0 px-2"
                style={{ height: "38px" }}
                onClick={() => handleRemove(index)}
              >
                <CloseOutlineIcon />
              </Button>
            </Col>
          </Row>
        );
      })}
      <button type="button" className="btn btn-primary btn-sm" onClick={addFields}>
        Add More..
      </button>
    </div>
  );
}
